export default __webpack_public_path__ + "/dist/images/logo4.ec9f9c40c73bcc166a6ec8732b947ed3.png";